module.exports = __webpack_public_path__ + "static/media/img_plan_free.200f49b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_plan_free.svg
// module id = 382
// module chunks = 0